<div class="container-xl" style="max-width: 1400px">
  <div class="row">
    <div class="col-12">
      <section class="settings-page">
        <!-- Page cover -->
        <div class="page-cover page-cover-user">
          <h1 class="welcome-text">Stores Management</h1>
        </div>

        @if (!isLoading) {
          <app-list-view #storesList [settings]="listViewSettings">
            <ng-template appItemLeadingActionsContent let-item="item">
              <button
                type="button"
                class="btn btn-danger btn-sm"
                (click)="deleteStore(item, storesList)"
                ngbTooltip="Delete store"
                placement="top"
                >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  >
                  <polyline points="3 6 5 6 21 6" />
                  <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                  <path d="M10 11v6" />
                  <path d="M14 11v6" />
                  <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                </svg>
              </button>
            </ng-template>
            <ng-template appItemActionsContent let-item="item">
              <button
                type="button"
                class="btn btn-dark btn-sm ml-2"
                (click)="openStoreWebsite(item)"
                ngbTooltip="Open store website"
                placement="top"
                >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  >
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                  <polyline points="15 3 21 3 21 9" />
                  <line x1="10" y1="14" x2="21" y2="3" />
                </svg>
              </button>
            </ng-template>
          </app-list-view>
        }
      </section>
    </div>
  </div>
</div>
